module.exports = __webpack_public_path__ + "static/media/Step 6.2ce9be41.mp3";